import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SimpleService } from '../../../../services/api-appointment/simple/simple.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { SimpleRequestSearch, SimpleAppointmentStatus } from '../../../../models/api-appointment/simple/simple.request.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css']
})




export class AppointmentComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  storeCity = '';
  isTargetMailList: boolean = false;
  status = [];
  storeAddress = '';
  request: any = {};
  public isEmpty: boolean = false;
  public isSearching: boolean = false;

  constructor(
    private simpleService: SimpleService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private router: Router,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: '',
      searchFilterField_completedOldValue: '',
      searchFilterField_completed: '',
      searchFilterField_reservedOldValue: '',
      searchFilterField_reserved: '',
      searchFilterField_reservedCheck: false,
      searchFilterField_completedCheck: false,
      searchFilterField_pendingCheck: false,
      searchFilterField_cancelledCheck: false,

    });
  }

  /**
* Inizializza la tabella
*/
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      {orderable: false,targets: 0,width:'15%'},
      {orderable: false,targets: 1,width:'15%'},
      {orderable: false,targets: 2,width:'15%'},
      {orderable: false,targets: 3,width:'10%'},
      {orderable: false,targets: 4,width:'15%'},
      {orderable: false,targets: 5,width:'10%'},
      {orderable: false,targets: 6,width:'5%'}
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;
      
      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      that.dimPagina = dataTablesParameters.length;
      let simpleRequestSearch = that.getFilter();
      that.simpleService.search(simpleRequestSearch).subscribe(
        (response) => {
          if(response != null){
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          }else{
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
  }

  ngOnInit() {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
  * Click sulla lente per la ricerca
  */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }


  filterReserved() {
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_reserved.value);
    this.resetFilter();
    this.ajaxReload();
  }

  filterCompleted() {
    this.searchFilterForm.controls.searchFilterField_completedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_completed.value);
    this.resetFilter();
    this.ajaxReload();
  }


  toggleCheckBoxes(elementToToggle) {
    let value = this.searchFilterForm.controls[elementToToggle].value
    this.searchFilterForm.controls[elementToToggle].setValue(!value);
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.value !== elementToToggle && item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
      if (i === listOfCheckboxes.length - 1) {
        this.changeFilter();
      }
    })
  }


  /**
   * Chiamata quando cambia un valore dei filtri
   */
  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.searchFilterForm.controls.searchFilterField_reserved.setValue(this.searchFilterForm.controls.searchFilterField_reservedOldValue.value);
    this.searchFilterForm.controls.searchFilterField_completed.setValue(this.searchFilterForm.controls.searchFilterField_completedOldValue.value);
    this.resetFilter();
    this.ajaxReload();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let simpleRequestSearch = new SimpleRequestSearch();
    // Search Bar
    simpleRequestSearch.address = this.searchFilterForm.controls['searchFilterField'].value;
    // Page Number
    simpleRequestSearch.pageNumber = this.numeroPagina;
    // Page Size
    simpleRequestSearch.pageSize = this.dimPagina;
    // Date Filter
    simpleRequestSearch.appointmentDate = this.searchFilterForm.controls['searchFilterField_reserved'].value;
    simpleRequestSearch.reservationDate = this.searchFilterForm.controls['searchFilterField_completed'].value;
    // Checkboxes
    if (this.searchFilterForm.controls['searchFilterField_completedCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.COMPLETED;
    }
    if (this.searchFilterForm.controls['searchFilterField_reservedCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.CONFIRMED;
    }
    if (this.searchFilterForm.controls['searchFilterField_pendingCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.PENDING;
    }
    if (this.searchFilterForm.controls['searchFilterField_cancelledCheck'].value == TRUE) {
      simpleRequestSearch.appointmentStatus = SimpleAppointmentStatus.CANCELLED;
    }

    simpleRequestSearch.sortBy = "createdAt:desc";

    return simpleRequestSearch;
  }

  clickButtonClearFilter() {
    // Search
    this.searchFilterForm.controls.searchFilterField.setValue('');
    // Date
    this.searchFilterForm.controls.searchFilterField_reserved.setValue('');
    this.searchFilterForm.controls.searchFilterField_completed.setValue('');
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue('');
    this.searchFilterForm.controls.searchFilterField_completedOldValue.setValue('');
    // Checkboxes
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
    })
    this.clickSearch();
  }


  clickButtonUpdate(id) {
    const url = 'appointment/appointment/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }


  goToCalendar() {
    const url = 'appointment/calendar';
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }
}
